import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/index.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/login'
  },
  {
    path: '/es/general/colabora',
    name: 'colabora',
    // component: () => import(/* webpackChunkName: "colabora" */ '../views/colabora.vue'),
    redirect: '/login'
  },
  {
    path: '/es/general/colabora-becas-alumni',
    name: 'colabora',
    // component: () => import(/* webpackChunkName: "colabora" */ '../views/colabora-becas.vue'),
    redirect: '/login'
  },
  {
    path: '/es/general/colabora-investigacion',
    name: 'colabora',
    // component: () => import(/* webpackChunkName: "colabora" */ '../views/colabora-investigacion.vue'),
    redirect: '/login'
  },
  {
    path: '/es/general/capilla-ufv',
    name: 'colabora',
    // component: () => import(/* webpackChunkName: "colabora" */ '../views/colabora-capilla.vue'),
    redirect: '/login'
  },
  {
    path: '/contacto',
    name: 'contacto',
    // component: () => import(/* webpackChunkName: "contacto" */ '../views/contacto.vue'),
    redirect: '/login'
  },
  {
    path: '/es/general/registro',
    name: 'registro',
    component: () => import(/* webpackChunkName: "registro" */ '../views/registro.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue'),
    meta: {
      noindex: true
    }
  },
  {
    path: '/solicitar-contrasena',
    name: 'solicitar-contrasena',
    component: () => import(/* webpackChunkName: "login" */ '../views/request-password.vue'),
    meta: {
      noindex: true
    }
  },
  {
    path: '/auth/reset-password/:token',
    name: 'establecer-contrasena',
    component: () => import(/* webpackChunkName: "login" */ '../views/set-password.vue'),
    meta: {
      noindex: true
    }
  },
  {
    path: '/activar-cuenta',
    name: 'activar-cuenta',
    component: () => import(/* webpackChunkName: "activar-cuenta" */ '../views/activar-cuenta.vue'),
    meta: {
      hideCompleta: true,
      noindex: true
    }
  },
  {
    path: '/es/mi-perfil/mis-datos-personales',
    name: 'datos-personales',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-personales.vue')
  },
  {
    path: '/es/mi-perfil/datos-club-senior',
    name: 'datos-club-senior',
    component: () => import(/* webpackChunkName: "login" */ '../views/datos-club-senior.vue')
  },
  {
    path: '/es/mi-perfil/mis-datos-academicos',
    name: 'datos-academicos',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-academicos.vue')
  },
  {
    path: '/es/mi-perfil/mis-datos-profesionales',
    name: 'datos-profesionales',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-profesionales.vue')
  },
  {
    path: '/es/mi-perfil/mis-datos-elumni',
    name: 'datos-elumni',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-elumni.vue')
  },
  {
    path: '/es/mi-perfil/mis-datos-internacional',
    name: 'datos-internacional',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-internacional.vue')
  },
  {
    path: '/es/mi-perfil/mis-datos-familiares',
    name: 'datos-familiares',
    component: () => import(/* webpackChunkName: "login" */ '../views/mis-datos-familiares.vue')
  },
  {
    path: '/es/mi-perfil/completa-tu-perfil',
    name: 'completa-tu-perfil',
    component: () => import(/* webpackChunkName: "login" */ '../views/completa-tu-perfil.vue'),
    meta: {
      hideCompleta: true
    }
  },
  {
    path: '/es/comunicacion/noticias',
    name: 'noticias',
    // component: () => import(/* webpackChunkName: "noticias" */ '../views/noticias.vue')
    redirect: '/login'
  },
  {
    path: '/es/comunicacion/noticias/:id?',
    name: 'noticia',
    // component: () => import(/* webpackChunkName: "noticia" */ '../views/noticia.vue')
    redirect: '/login'
  },
  {
    path: '/es/comunicacion/entrevistas',
    name: 'entrevistas',
    redirect: '/login'
  },
  {
    path: '/es/comunicacion/entrevistas/:id?',
    name: 'entrevista',
    // component: () => import(/* webpackChunkName: "entrevista" */ '../views/entrevista.vue')
    redirect: '/login'
  },
  {
    path: '/es/comunidad/eventos',
    name: 'eventos',
    // component: () => import(/* webpackChunkName: "eventos" */ '../views/eventos.vue')
    redirect: '/login'
  },
  {
    path: '/es/comunidad/eventos/:id',
    name: 'evento-ficha',
    component: () => import(/* webpackChunkName: "evento-ficha" */ '../views/evento-ficha.vue')
  },
  {
    path: '/es/general/encuesta-padres',
    name: 'formulario-padres',
    component: () => import(/* webpackChunkName: "formulario-padres" */ '../views/formulario-padres.vue')
  },
  {
    path: '/es/general/registro-alumni',
    name: 'formulario-alumni',
    component: () => import(/* webpackChunkName: "formulario-alumni" */ '../views/formulario-alumni.vue')
  },
  {
    path: '/es/general/encuesta-alumni',
    redirect: to => ({ path: '/es/general/registro-alumni', query: to.query })
  },
  {
    path: '/es/general/encuesta-medicina',
    name: 'formulario-medicina',
    // component: () => import(/* webpackChunkName: "formulario-medicina" */ '../views/formulario-medicina.vue')
    redirect: '/login'
  },
  {
    path: '/es/general/encuesta-farmacia',
    name: 'formulario-farmacia',
    // component: () => import(/* webpackChunkName: "formulario-farmacia" */ '../views/formulario-farmacia.vue')
    redirect: '/login'
  },
  {
    path: '/es/general/encuesta-biomed',
    name: 'formulario-biomed',
    // component: () => import(/* webpackChunkName: "formulario-biomed" */ '../views/formulario-biomed.vue')
    redirect: '/login'
  },
  {
    path: '/es/general/encuesta-fisioterapia',
    name: 'formulario-fisioterapia',
    // component: () => import(/* webpackChunkName: "formulario-biomed" */ '../views/formulario-fisioterapeutas.vue')
    redirect: '/login'
  },
  {
    path: '/es/general/politica-privacidad',
    name: 'politica-privacidad',
    // component: () => import(/* webpackChunkName: "politica-privacidad" */ '../views/politica-privacidad.vue'),
    redirect: '/login',
    meta: {
      noindex: true
    }
  },
  {
    path: '/es/general/aviso-legal',
    name: 'aviso-legal',
    // component: () => import(/* webpackChunkName: "aviso-legal" */ '../views/aviso-legal.vue'),
    redirect: '/login',
    meta: {
      noindex: true
    }
  },
  {
    path: '/es/general/politica-cookies',
    name: 'politica-cookies',
    // component: () => import(/* webpackChunkName: "politica-cookies" */ '../views/politica-cookies.vue'),
    redirect: '/login',
    meta: {
      noindex: true
    }
  },
  {
    path: '/evento-alumni/:id',
    name: 'evento-abierto',
    component: () => import(/* webpackChunkName: "evento-abierto" */ '../views/evento-abierto.vue')
  },
  {
    path: '/auth/login',
    redirect: '/login'
  },
  {
    path: '*',
    redirect: '/login'
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return (savedPosition) ? savedPosition : { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  //COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO
  if (to.name === 'login') {
    store.commit('setLogout');
  }

  if (to.matched.some(route => route.meta.requireAuth) && !store.getters.getLogged) {
    next({ name: 'login' })
    return
  }

  const robots = document.querySelector('meta[name="robots"]');
  if (!robots) return;
  if (to.meta.noindex) {
    robots.setAttribute("content", "noindex, follow");
  } else {
    robots.setAttribute("content", "index, follow");
  }
  next()
});

export default router
